export const ACCEPTED_COLOR = '#2ecc51'; //8BC34A';
export const REJECTED_COLOR = '#ff6347'; //EF0000';
export const UNCLASSIFIED_COLOR = '#FFFFFF';
export const HISTORY_LENGTH = 20;
export const NETWORKSETTINGSINIT = {isEnabled: true, useDHCP: true, ipv4: {ip: '', gateway: ''}, dns: {primary: '', secondary: ''}};
